// We only need to import the modules necessary for initial render
// When you add a first route be sure to remove the comment from the lines below.

import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
// import rootStore from 'Store/createStore'
// import asyncComponent from 'Hoc/AsyncComponent'
import LazyComponent from 'Hoc/LazyComponent'

const Dashboard = lazy(() => import(/* webpackChunkName: "Dashboard" */ './Dashboard'))
const OrderManagement = lazy(() => import(/* webpackChunkName: "OrderManagement" */ './OrderManagement'))
const Profile = lazy(() => import(/* webpackChunkName: "Profile" */ './Profile'))
const Reports = lazy(() => import(/* webpackChunkName: "Reports" */ './Reports'))
const OperationManagement = lazy(() => import(/* webpackChunkName: "OperationManagement" */ './OperationManagement'))
const Login = lazy(() => import(/* webpackChunkName: "Login" */ './Login'))
const Authorize = lazy(() => import(/* webpackChunkName: "Authorize" */ './Authorize'))
const RecoveryCredentials = lazy(() => import(/* webpackChunkName: "RecoveryCredentials" */ './RecoveryCredentials'))
const SubscriptionPlan = lazy(() => import(/* webpackChunkName: "SubscriptionPlan" */ './SubscriptionPlan'))
const ResetPassword = lazy(() => import(/* webpackChunkName: "ResetPassword" */ './ResetPassword'))
const ChangePassword = lazy(() => import(/* webpackChunkName: "ChangePassword" */ './ChangePassword'))
const CreatePayByLinkPlus = lazy(() => import(/* webpackChunkName: "CreatePayByLinkPlus" */ './CreatePayByLinkPlus'))
const Moto = lazy(() => import(/* webpackChunkName: "Moto" */ './Moto'))
const CardCheck = lazy(() => import(/* webpackChunkName: "CardCheck" */ './CardCheck'))
const TerminalsManagement = lazy(() => import(/* webpackChunkName: "TerminalsManagement" */ './TerminalsManagement'))
const Users = lazy(() => import(/* webpackChunkName: "Users" */ './Users'))
const BookingManagement = lazy(() => import(/* webpackChunkName: "BookingManagement" */ './BookingManagement'))
const PblManagement = lazy(() => import(/* webpackChunkName: "PblManagement" */ './PblManagement'))
const ExpiredSession = lazy(() => import(/* webpackChunkName: "ExpiredSession" */ './ExpiredSession'))
const PointsOfSales = lazy(() => import(/* webpackChunkName: "PointsOfSales" */ './PointsOfSales'))
const PayToCard = lazy(() => import(/* webpackChunkName: "PayToCard" */ './PayToCard'));
// @generator routes:import

export const Components = {
  // @generator routes:component export
  PayToCard,
  PointsOfSales,
  ExpiredSession,
  BookingManagement,
  PblManagement,
  CreatePayByLinkPlus,
  CardCheck,
  Users,
  TerminalsManagement,
  SubscriptionPlan,
  Moto,
  ChangePassword,
  ResetPassword,
  RecoveryCredentials,
  Authorize,
  Login,
  Reports,
  OperationManagement,
  Profile,
  OrderManagement,
  Dashboard
}

export const createAuthRoutes = () => ({
  routes: [
    {
      key: 'Dashboard',
      component: (props) => (
        <Route
          path='/*'
          key='Dashboard'
          element={<LazyComponent componentName='Dashboard' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'OperationManagement',
      component: (props) => (
        <Route
          path='/operationmanagement/*'
          key='OperationManagement'
          element={<LazyComponent componentName='OperationManagement' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'OrderManagement',
      component: (props) => (
        <Route
          path='/ordermanagement/*'
          key='OrderManagement'
          element={<LazyComponent componentName='OrderManagement' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Profile',
      component: (props) => (
        <Route
          path='/profile/*'
          key='Profile'
          element={<LazyComponent componentName='Profile' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Reports',
      component: (props) => (
        <Route
          path='/reports/*'
          key='Reports'
          element={<LazyComponent componentName='Reports' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'CreatePayByLinkPlus',
      component: (props) => (
        <Route
          path='/createpaybylinkplus/*'
          key='CreatePayByLinkPlus'
          element={<LazyComponent componentName='CreatePayByLinkPlus' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'SubscriptionPlan',
      component: (props) => (
        <Route
          path='/subscriptionplan/*'
          key='SubscriptionPlan'
          element={<LazyComponent componentName='SubscriptionPlan' {...props} hasSaga hasReducer hasLayout />}
        />
      )
    },
    {
      key: 'Moto',
      component: (props) => (
        <Route
          path='/moto/*'
          key='Moto'
          element={<LazyComponent componentName='Moto' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'CardCheck',
      component: (props) => (
        <Route
          path='/cardcheck/*'
          key='CardCheck'
          element={<LazyComponent componentName='CardCheck' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'TerminalsManagement',
      component: (props) => (
        <Route
          path='/terminalsmanagement/*'
          key='TerminalsManagement'
          element={<LazyComponent componentName='TerminalsManagement' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Users',
      component: (props) => (
        <Route
          path='/users/*'
          key='Users'
          element={<LazyComponent componentName='Users' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'BookingManagement',
      component: (props) => (
        <Route
          path='/bookingmanagement/*'
          key='BookingManagement'
          element={<LazyComponent componentName='BookingManagement' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'PblManagement',
      component: (props) => (
        <Route
          path='/pblmanagement/*'
          key='PblManagement'
          element={<LazyComponent componentName='PblManagement' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'PointsOfSales',
      component: (props) => (
        <Route
          path='/pointsofsales/*'
          key='PointsOfSales'
          element={<LazyComponent componentName='PointsOfSales' {...props} hasSaga hasReducer />}
        />
      )
    }, 
    {
      key: 'PayToCard',
      component: (props) => (
        <Route
          path='/paytocard/*'
          key='PayToCard'
          element={  <LazyComponent componentName="PayToCard"  {...props} hasSaga hasReducer />}
        />
      )
    },// @generator routes:define:auth

  ]
})

// These routes don't need the user to be logged in.

export const createUnauthRoutes = () => ({
  routes: [
    {
      key: 'Login',
      component: (props) => (
        <Route
          path='/login/*' // Login without theme in the path because have providerId param
          key='Login'
          element={<LazyComponent componentName='Login' {...props} hasSaga hasReducer noAuth />}
        />
      )
    },
    {
      key: 'Authorize',
      component: (props) => (
        <Route
          path='/authorize/*'
          key='Authorize'
          element={<LazyComponent componentName='Authorize' {...props} hasSaga hasReducer noAuth/>}
        />
      )
    },
    {
      key: 'RecoveryCredentials',
      component: (props) => (
        <Route
          path='/recoverycredentials/*'
          key='RecoveryCredentials'
          element={<LazyComponent componentName='RecoveryCredentials' {...props} hasSaga hasReducer noAuth />} // Send recovery credentials mail flow
        />
      )
    },
    {
      key: 'ResetPassword',
      component: (props) => (
        <Route
          path='/reset-password/*'
          key='ResetPassword'
          element={<LazyComponent componentName='ResetPassword' {...props} hasSaga hasReducer noAuth />} // Reset password from email link
        />
      )
    },
    {
      key: 'ChangePassword',
      component: (props) => (
        <Route
          path='/changepassword/*'
          key='ChangePassword'
          element={<LazyComponent componentName='ChangePassword' {...props} hasSaga hasReducer noAuth />} // Change password from Login ( Expired password )
        />
      )
    },
    {
      key: 'ExpiredSession',
      component: (props) => (
        <Route
          path='/expired-session/*'
          key='ExpiredSession'
          element={<LazyComponent componentName="ExpiredSession"  {...props} noAuth />}
        />
      )
    } // @generator routes:define:unauth
  ]
})

export default createAuthRoutes
